export default __webpack_public_path__ + "static/media/menu.2ef599e8.svg";